"use client";

import { useEffect } from "react";

const captureException = (error: unknown) => {
  void import("@sentry/nextjs")
    .then((Sentry) => {
      Sentry.captureException(error);
    })
    .catch(() => {});
};

type GlobalErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <main
          style={{
            minHeight: "100vh",
            display: "grid",
            placeItems: "center",
            padding: "2rem",
            fontFamily: "var(--font-app, sans-serif)",
            background: "#f6f7f9",
            color: "#111827",
          }}
        >
          <div style={{ maxWidth: 480, textAlign: "center" }}>
            <h1 style={{ fontSize: "1.75rem", marginBottom: "0.75rem" }}>
              Something went wrong
            </h1>
            <p style={{ marginBottom: "1.25rem", lineHeight: 1.6 }}>
              An unexpected error occurred. The issue has been recorded.
            </p>
            <button
              type="button"
              onClick={() => reset()}
              style={{
                border: 0,
                borderRadius: 999,
                padding: "0.75rem 1.25rem",
                background: "#25292E",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Try again
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
